const SESSION_KEY = 'analytics:session_id';

export function getSessionId(): string {
  try {
    let id = sessionStorage.getItem(SESSION_KEY);
    if (!id) {
      id =
        typeof crypto !== 'undefined' && 'randomUUID' in crypto
          ? crypto.randomUUID()
          : `sess-${Date.now()}-${Math.random().toString(36).slice(2)}`;
      sessionStorage.setItem(SESSION_KEY, id);
    }
    return id;
  } catch {
    // sessionStorage unavailable (private mode); fall back to a volatile id.
    return `sess-${Date.now()}-${Math.random().toString(36).slice(2)}`;
  }
}

export function getAppVersion(): string {
  return process.env.REACT_APP_VERSION || 'unknown';
}

export function detectBrowser(ua: string = navigator.userAgent): string {
  const edge = ua.match(/Edg\/(\d+)/);
  if (edge) return `Edge ${edge[1]}`;
  const chrome = ua.match(/Chrome\/(\d+)/);
  if (chrome && !/OPR|Edg/.test(ua)) return `Chrome ${chrome[1]}`;
  const firefox = ua.match(/Firefox\/(\d+)/);
  if (firefox) return `Firefox ${firefox[1]}`;
  const safari = ua.match(/Version\/(\d+).* Safari/);
  if (safari) return `Safari ${safari[1]}`;
  return 'Other';
}

export function detectOS(ua: string = navigator.userAgent): string {
  if (/iPhone|iPad|iPod/.test(ua)) return 'iOS';
  if (/Android/.test(ua)) return 'Android';
  if (/Mac OS X/.test(ua)) return 'macOS';
  if (/Windows/.test(ua)) return 'Windows';
  if (/Linux/.test(ua)) return 'Linux';
  return 'Other';
}
